import React from 'react';
import styled, { keyframes } from 'styled-components';

import { Color, colors } from 'theme';

type Size = 'text' | 'micro' | 'small' | 'default' | '2x' | '3x';
const SIZES: Record<Size, number> = {
  text: 3,
  micro: 4,
  small: 6,
  default: 10,
  '2x': 20,
  '3x': 30,
};
const DURATION = 0.5;
const aFloat = keyframes`
  0% {
    transform: translateY(-75%);
  }
  100% {
    transform: translateY(75%);
  }
`;
const Dot = styled.div`
  /* dot */
`;
const StyledSpinner = styled.div<{ size: Size }>`
  position: relative;
  ${(props) => `
    width: ${SIZES[props.size]}px;
    height: ${SIZES[props.size]}px;
    color: ${props.color === 'default' ? 'currentColor' : colors[props.color]};
  `}
  &::before,
  &::after,
  ${Dot} {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: currentColor;
    animation: ${aFloat} ${DURATION}s ease-in infinite alternate;
    will-change: animation;
  }
  &::before,
  &::after {
    content: '';
  }
  &::before {
    right: 200%;
    animation-delay: -${DURATION / 5}s;
  }
  ${Dot} {
    left: 0;
    animation-delay: -${DURATION / 3 + DURATION / 5}s;
  }
  &::after {
    left: 200%;
    animation-delay: -${(DURATION * 2) / 3 + DURATION / 5}s;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const Spinner = ({
  size = 'default',
  label = 'Loading',
  color = 'default',
}: {
  size?: Size;
  label?: string;
  color?: Color | 'default';
}) => (
  <StyledSpinner size={size} color={color} aria-label={label}>
    <Dot />
  </StyledSpinner>
);

// eslint-disable-next-line import/no-default-export
export default Spinner;
